<ng-container [ngSwitch]="facet.type">
  <ng-container *ngSwitchCase="'hierarchy'">
    <div
      [ngClass]="{ active: _open }"
      (click)="openFacet($event)"
      class="filter-label d-flex justify-content-between align-items-center w-100 action"
    >
      <h6>{{ facet.title }}</h6>
      <img
        [ngClass]="{ rotate: _open }"
        width="16"
        height="16"
        class="ms-2"
        src="/assets/caret.svg"
      />
    </div>
    <div [ngClass]="{ collapse: !_open }" class="check-list">
      <label
        class="d-flex flex-column align-items-start action"
        (click)="openChildFacet(value); preventDefault($event)"
        *ngFor="let value of facet.values"
        [ngClass]="{
          active: value._active !== undefined ? value._active : value.active
        }"
      >
        <div
          class="check w-100"
          [ngClass]="{ 'mb-1': value.children && value.children.length > 0 }"
        >
          <input
            class="plut-input d-none"
            type="checkbox"
            [ngModel]="
              value._active !== undefined ? value._active : value.active
            "
          />
          <span class="plut-check" (click)="selectMultiFilter(value)"></span>
          <span class="plut-label" (click)="selectMultiFilter(value)">
            {{ value.label }}
          </span>
          <img
            *ngIf="value.children && value.children.length > 0"
            [ngClass]="{ rotate: value._open }"
            width="16"
            height="16"
            class="ms-auto"
            src="/assets/caret.svg"
          />
        </div>
        <div
          class="check-list"
          [ngClass]="{ collapse: !value._open }"
          *ngIf="value.children && value.children.length > 0"
        >
          <label
            class="check ps-2"
            *ngFor="let child of value.children"
            [ngClass]="{
              active: child._active !== undefined ? child._active : child.active
            }"
          >
            <input
              class="plut-input d-none"
              type="checkbox"
              [ngModel]="
                child._active !== undefined ? child._active : child.active
              "
            />
            <span
              class="plut-check"
              (click)="selectMultiFilterChild(child, value)"
            ></span>
            <span
              class="plut-label"
              (click)="selectMultiFilterChild(child, value)"
            >
              {{ child.label }}
            </span>
          </label>
        </div>
      </label>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'colour'">
    <div
      [ngClass]="{ active: _open }"
      (click)="openFacet($event)"
      class="filter-label d-flex justify-content-between align-items-center w-100 action"
    >
      <h6>{{ facet.title }}</h6>
      <img
        [ngClass]="{ rotate: _open }"
        width="16"
        height="16"
        class="ms-2"
        src="/assets/caret.svg"
      />
    </div>
    <div [ngClass]="{ collapse: !_open }" class="check-list">
      <label
        *ngFor="let value of facet.values"
        class="w-100 d-flex align-items-center swatch-entry action"
        [ngClass]="{
          active: value._active !== undefined ? value._active : value.active
        }"
        (click)="selectFilter(value)"
      >
        <div
          class="swatch my-auto"
          [style.background-image]="value.meta.img"
          [style.background-color]="value.meta.hex"
        ></div>
        <span class="plut-label">
          {{ value.label }}
        </span>
      </label>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'variant_size'">
    <div
      [ngClass]="{ active: _open }"
      (click)="openFacet($event)"
      class="filter-label d-flex justify-content-between align-items-center w-100"
    >
      <h6>{{ facet.title }}</h6>
      <img
        [ngClass]="{ rotate: _open }"
        width="16"
        height="16"
        class="ms-2"
        src="/assets/caret.svg"
      />
    </div>
    <div [ngClass]="{ collapse: !_open }" class="check-list">
      <ng-container *ngFor="let size of _uniqueSizes">
        <h6 class="size-title" *ngIf="_uniqueSizes.length > 1">{{ size }}</h6>
        <ng-container *ngFor="let value of facet.values">
          <label
            class="check"
            *ngIf="value.group == size"
            [ngClass]="{
              active: value._active !== undefined ? value._active : value.active
            }"
          >
            <input
              class="plut-input d-none"
              type="checkbox"
              [ngModel]="
                value._active !== undefined ? value._active : value.active
              "
            />
            <span class="plut-check" (click)="selectFilter(value)"></span>
            <span class="plut-label" (click)="selectFilter(value)">
              {{ value.label }}
            </span>
          </label>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div
      [ngClass]="{ active: _open }"
      (click)="openFacet($event)"
      class="filter-label d-flex justify-content-between align-items-center w-100 action"
    >
      <h6>{{ facet.title }}</h6>
      <img
        [ngClass]="{ rotate: _open }"
        width="16"
        height="16"
        class="ms-2"
        src="/assets/caret.svg"
      />
    </div>
    <div [ngClass]="{ collapse: !_open }" class="check-list">
      <label
        class="check action"
        *ngFor="let value of facet.values"
        [ngClass]="{
          active: value._active !== undefined ? value._active : value.active
        }"
      >
        <span (click)="selectFilter(value)" class="plut-check">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              opacity="0.9"
              cx="12"
              cy="12.7383"
              r="8"
              stroke="black"
              stroke-linecap="square"
            />
            <circle
              *ngIf="value.active"
              opacity="0.9"
              cx="12"
              cy="12.7383"
              r="4"
              fill="black"
            />
          </svg>
        </span>
        <span (click)="selectFilter(value)" class="plut-label">
          {{ value.label }}
        </span>
      </label>
    </div>
  </ng-container>
</ng-container>
